import { AxiosAuthRefreshRequestConfig } from "axios-auth-refresh";
import * as sup from "superstruct";

import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import { createResponseStruct } from "@/modules/api/utils/jsonApiStructs";
import { credentialsResourceType } from "@/modules/auth/api/resources/credentials/credentialsResourceConsts";
import { sessionResourcePath } from "@/modules/auth/api/resources/session/sessionResourceConsts";
import { sessionResourceStruct } from "@/modules/auth/api/resources/session/sessionResourceStruct";
import { userResourceStruct } from "@/modules/auth/api/resources/user/userResourceStruct";

export function signInMutation(jsonApi: JsonApiClient) {
  return (attributes: { email: string; password: string }) =>
    jsonApi.createOne({
      type: credentialsResourceType,
      path: sessionResourcePath,
      attributes,
      responseStruct: signInResponseStruct,
      axiosConfig: {
        skipAuthRefresh: true,
      } as AxiosAuthRefreshRequestConfig,
    });
}

const signInResponseStruct = createResponseStruct({
  data: sessionResourceStruct,
  included: sup.array(userResourceStruct),
});

export type SignInResponse = sup.Infer<typeof signInResponseStruct>;
